import { render } from "./MySitesMenu.vue?vue&type=template&id=1d7b9bce"
import script from "./MySitesMenu.vue?vue&type=script&lang=ts"
export * from "./MySitesMenu.vue?vue&type=script&lang=ts"

import "./MySitesMenu.vue?vue&type=style&index=0&id=1d7b9bce&lang=scss"
script.render = render

export default script